<template>
  <div class="dash-board">
    <el-row :gutter="38">
      <el-col :span="queryColSpan">
        <div class="item">
          <div class="value">
            <span>{{ dv.total || 0 }}</span>个
          </div>
          <div class="label">我的广告主总数</div>
          <div class="r-img">
            <img
              class="bg-img"
              :src="circleBlue"
            >
          </div>
        </div>
      </el-col>
      <el-col :span="queryColSpan">
        <div class="item">
          <div class="value">
            <span>{{ dv.open_pass || 0 }}</span>个
          </div>
          <div class="label">我已开户产品数</div>
          <div class="r-img">
            <img
              class="bg-img"
              :src="circleOrange"
            >
          </div>
        </div>
      </el-col>
      <el-col :span="queryColSpan">
        <div class="item">
          <div class="value">
            <span>{{ dv.no_open || 0 }}</span>个
          </div>
          <div class="label">我未开户产品(含开户中)数</div>
          <div class="r-img">
            <img
              class="bg-img"
              :src="circlePurple"
            >
          </div>
        </div>
      </el-col>
      <el-col :span="queryColSpan">
        <div class="item">
          <div class="value">
            <span>{{ dv.left_over || 0 }}</span>个
          </div>
          <div class="label">我的私海剩余名额</div>
          <div class="r-img">
            <img
              class="bg-img"
              :src="circleGreen"
            >
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CircleBlue from '@/assets/image/icon/circle-blue.png';
import CircleOrange from '@/assets/image/icon/circle-orange.png';
import CircleGreen from '@/assets/image/icon/circle-green.png';
import CirclePurple from '@/assets/image/icon/circle-purple.png';
import queryGridByContainer from '@/common/js/queryGridByContainer';

export default {
  name: 'Dashboard',

  props: {
    dv: {
      type: Object,
      default: () => ({}),
    },
  },

  mixins: [queryGridByContainer],

  data() {
    return {
      circleBlue: CircleBlue,
      circleOrange: CircleOrange,
      circleGreen: CircleGreen,
      circlePurple: CirclePurple,
    };
  },
};
</script>
<style lang="less" scoped>
.dash-board {
  .item {
    // width:254px;
    margin-bottom: 8px;
    position: relative;
    box-sizing: border-box;
    height: 90px;
    padding: 12px 16px 16px 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(32, 45, 112, 0.1),
      0px 0px 2px 0px rgba(32, 45, 112, 0.04);
    border-radius: 8px;
    p {
      margin: 0;
    }

    .label {
      color: #909399;
      font-size: 14px;
      margin-bottom: 4px;
      padding-top: 1px;
    }
    .value {
      font-size: 14px;
      color: #373c40;

      span {
        font-size: 36px;
        color: #303133;
        margin-right: 4px;
      }
    }
    .r-img {
      position: absolute;
      top: 0;
      right: 0;
      height: 90px;
      .bg-img {
        height: 90px;
      }
    }
  }
}
</style>
